import script from "./Services.vue?vue&type=script&setup=true&lang=js"
export * from "./Services.vue?vue&type=script&setup=true&lang=js"

import "./Services.vue?vue&type=style&index=0&id=1ac0db3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac0db3a"]])

export default __exports__